import * as React from 'react';
import { IconProps } from '../types';

const IcDeduction = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill={props?.fill ?? '#232F3E'}
        d="m15.06 19.56-1.5-1.5L17 14.622l-4.19-4.189-4.5 4.5L.5 7.122 2.62 5l5.69 5.69 4.5-4.5 6.31 6.31 3.44-3.44 1.5 1.5v9h-9Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h24v24H.5z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcDeduction;
